import { API_URL, getApiV1BaseUrl } from '@/constants'

export const logOut = async () => {
  const response = await fetch(`${getApiV1BaseUrl()}${API_URL.AUTH.LOGOUT}`, {
    method: 'POST',
    credentials: 'include',
  })
  if (response.ok) {
    localStorage.clear()
  }
}
